import type { Feature } from '../types';

const EyeIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor" />
    </svg>
);

const LeafIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 008 20C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5a6.22 6.22 0 001.75 3.75C7 8 17 8 17 8z" fill="currentColor" />
    </svg>
);

const BoxIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18s-.41-.06-.57-.18l-7.9-4.44A.991.991 0 013 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18s.41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9zM12 4.15L6.04 7.5 12 10.85l5.96-3.35L12 4.15zM5 8.61v6.7l6 3.37v-6.67L5 8.61zm8 6.7v6.67l6-3.37v-6.7l-6 3.37z" fill="currentColor" />
    </svg>
);

const FEATURES: Feature[] = [
    {
        icon: <EyeIcon />,
        title: 'AI Thinking Personas',
        description: 'Examine choices through multiple angles. Engage with proprietary AI agents (Magnolia, Camellia, Peony) to view complex financial data through distinct lenses of stability, preservation, and growth.',
    },
    {
        icon: <LeafIcon />,
        title: 'The Stewardship Dashboard',
        description: 'A distraction-free, zero-urgency workspace designed for deep reflection. Escape the pressure of rapid-fire markets to assess risks and make calmer, deliberate choices.',
        highlight: true,
    },
    {
        icon: <BoxIcon />,
        title: 'Foundational Thinking Framework',
        description: 'A sophisticated multi-agent ecosystem that rigorously debates assumptions and expands your perspective, providing the multi-angle clarity needed to think wisely before taking action.',
    },
];

export const Features = () => {
    return (
        <section className="features section" id="features">
            <div className="container">
                <div className="section__header">
                    <span className="section__badge">Features</span>
                    <h2 className="section__title">Wealth Tools for Deliberate Stewardship</h2>
                    <p className="section__description">
                        A structured ecosystem of tools to help you navigate complex allocations, evaluate hidden risks, and protect your family's long-term wealth.
                    </p>
                </div>

                <div className="features__grid">
                    {FEATURES.map((feature) => (
                        <article key={feature.title} className={`feature-card ${feature.highlight ? 'feature-card--highlight' : ''}`}>
                            <div className="feature-card__icon">{feature.icon}</div>
                            <h3 className="feature-card__title">{feature.title}</h3>
                            <p className="feature-card__description">{feature.description}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};